import { render, staticRenderFns } from "./details-info.vue?vue&type=template&id=1c795044"
import script from "./details-info.vue?vue&type=script&lang=js"
export * from "./details-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c795044')) {
      api.createRecord('1c795044', component.options)
    } else {
      api.reload('1c795044', component.options)
    }
    module.hot.accept("./details-info.vue?vue&type=template&id=1c795044", function () {
      api.rerender('1c795044', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/deviceInfo-manage/subgroup/details-info.vue"
export default component.exports